import React from 'react';

import { Editor } from '@craftjs/core';

import {
  EmailEditorSigningOff,
  EmailEditorShippingTo,
  EmailEditorSenderInfo,
  EmailEditorGreeting,
  EmailEditorAdditionalInfo,
  EmailEditorProductRequested,
  EmailEditorFreeText,
  EditorToolbar,
  EmailEditorFrame,
  EmailEditorGetHtml,
} from './components';

import { EmailEditorProvider } from './controllers/context';

import './style.less';

let timeout;
const EmailEditor = (props) => {
  const {
    dynamicContent,
    productData,
    contactEmail,
    invalidTag,
    setInvalidTag,
    dataRef,
    senderInfo,
    template,
    requestSampleData,
    setRequestSampleData,
  } = props;

  const onNodeChange = (query) => {
    const json = query.serialize();

    timeout = setTimeout(() => {
      setRequestSampleData((pre) => {
        return {
          ...pre,
          [contactEmail]: {
            ...pre[contactEmail],
            editorData: json,
          },
        };
      });
    }, 100);
  };

  return (
    <EmailEditorProvider
      dynamicContent={dynamicContent}
      productData={productData}
      invalidTag={invalidTag}
      setInvalidTag={setInvalidTag}
      senderInfo={senderInfo}
      template={template}
      contactEmail={contactEmail}
      requestSampleData={requestSampleData}
      setRequestSampleData={setRequestSampleData}
    >
      <Editor
        resolver={{
          EmailEditorSigningOff,
          EmailEditorShippingTo,
          EmailEditorSenderInfo,
          EmailEditorGreeting,
          EmailEditorAdditionalInfo,
          EmailEditorProductRequested,
          EmailEditorFreeText,
        }}
        onNodesChange={onNodeChange}
      >
        <EditorToolbar />
        <EmailEditorFrame />
        <EmailEditorGetHtml
          ref={dataRef}
          editorData={requestSampleData[contactEmail]?.editorData}
        />
      </Editor>
    </EmailEditorProvider>
  );
};

export default EmailEditor;
